/* eslint-disable max-len */
import React from 'react';
import { SvgProps, IconType } from '../../types/types';

export const Momentum: IconType = (props: SvgProps) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.0005 30.0372V18.9269C10.0005 17.7368 10.7995 16.6948 11.9488 16.3861L28.6872 11.89C30.3584 11.4411 32.0005 12.7002 32.0005 14.4308V33.6529C32.0005 40.5473 27.39 41.5322 25.1699 40.5473C20.3021 38.3877 20.8296 32.8188 25.4357 30.8177C26.6293 30.2992 27.6094 29.2435 27.6094 27.9422V22.3204C27.6094 20.5867 25.9617 19.327 24.2887 19.7817L16.8053 21.8152C15.6878 22.1189 14.9003 23.1176 14.8656 24.2751L14.4362 38.5775C14.4362 43.0096 8.41576 44.0124 6.44645 42.0247C3.52477 39.0756 5.23717 35.2988 7.57913 33.5859C8.75189 32.7281 10.0005 31.4902 10.0005 30.0372Z"
        stroke="#7D7FE8"
        strokeWidth="2.63084"
      />
      <path
        d="M39 38.8118C39 40.5916 40.4296 41.3903 42.514 40.8161C43.463 40.5547 44 39.6033 44 38.6189V35.1108C41.4971 35.1108 39 35.992 39 38.8118Z"
        fill="#6668C4"
      />
      <path
        d="M44 30V35.1108M44 35.1108V38.6189C44 39.6033 43.463 40.5547 42.514 40.8161C40.4296 41.3903 39 40.5916 39 38.8118C39 35.992 41.4971 35.1108 44 35.1108Z"
        stroke="#6668C4"
        strokeWidth="2.63084"
        strokeLinecap="round"
      />
      <path
        d="M36 19.016C36 21.5796 37.9138 22.6505 40.6459 21.5994C41.5171 21.2643 42 20.3652 42 19.4317V13.9693C38.9965 13.9693 36 15.1709 36 19.016Z"
        fill="#B1B2F1"
      />
      <path
        d="M42 7V13.9693M42 13.9693V19.4317C42 20.3652 41.5171 21.2643 40.6459 21.5994C37.9138 22.6505 36 21.5796 36 19.016C36 15.1709 38.9965 13.9693 42 13.9693Z"
        stroke="#B1B2F1"
        strokeWidth="2.63084"
        strokeLinecap="round"
      />
    </svg>
  );
};
